import React, { useCallback, useEffect, useState } from 'react';
import { Empty } from 'antd';
import useSWR from 'swr';

const monthNames = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

import { moneyFormatter, useHandleSWR } from '~/libs/helpers'
import { ComposedChart, Line, XAxis, Bar, 
  YAxis, ReferenceLine, ResponsiveContainer, Tooltip } from 'recharts';
import { CenteredContainer } from '../layouts/Containers';
import useGlobalState from '~/libs/context';

const PNLChart = (props) => {
  const { setMonth = () => {} } = props;
  const [ hasData, setHasData ] = useState(false);
  const [ chartData, setChartData ] = useState();
  const { year } = useGlobalState();
	const { data: swrProfitLoss } = useSWR(`/api/metrics/profitLoss?year=${year}`);
  const { data: profitLoss } = useHandleSWR(swrProfitLoss, { sales: [], purchases: [], expenses: [] }, true);

  useEffect(() => {
    let data = [];
    let localHasData = false;
    for (let c = 0; c < monthNames.length; c++) {
      const sales = profitLoss.sales.map(acc => { return acc.months[c] }).reduce((a, b) => a + b, 0);
      const purchases = profitLoss.purchases.map(acc => { return acc.months[c] }).reduce((a, b) => a + b, 0) * -1;
      const expenses = profitLoss.expenses.map(acc => { return acc.months[c] }).reduce((a, b) => a + b, 0) * -1;
      const profits = sales - (purchases + expenses);
      if (purchases || expenses || profits) {
        localHasData = true;
      }
      data.push({ month: c + 1 + '月', incomes: sales, expenses: purchases + expenses, profits });
    }

    if (hasData !== localHasData) {
      setHasData(localHasData)
      if (localHasData) {
        setChartData(data);
      }
    }
  }, [profitLoss]);

  const onMouseLeaveChart = useCallback(() => {
    setMonth(null);
  });

  const onMouseMoveAround = useCallback((info) => {
    let month = info.activeLabel;
    month = month ? parseInt(month.toString().replace('月', '')) : null;
    setMonth(month);
  });

  if (!hasData) {
    return <CenteredContainer style={{ height: 400 }}><Empty /></CenteredContainer>;
  }

	return (
    <ResponsiveContainer width="100%" height={400}>
      <ComposedChart data={chartData} onMouseLeave={onMouseLeaveChart} barGap={0} onMouseMove={onMouseMoveAround}>
        <XAxis dataKey="month" tickMargin={12} tick={{ fontSize: 12 }} />
        <YAxis type="number" tickFormatter={(x) => moneyFormatter(x)} tick={{ fontSize: 11 }} />
        <Tooltip />
        {/* <CartesianGrid stroke="#f5f5f5" /> */}
        <Bar dataKey="incomes"fill="#17A12EAA" background={{ fill: '#F0F0F055' }} />
        <Bar dataKey="expenses" fill="#B63838AA" background={{ fill: '#F0F0F055' }} />
        <Line dataKey="profits" stroke="#F2C94C" strokeWidth={4} />
        <ReferenceLine y={0} stroke="black" />
      </ComposedChart>
    </ResponsiveContainer>
	);
};

export default PNLChart;